import { Close } from "components/assets/Icons";
import { useRef } from "react";
import useOnClickOutside from "utils/useOnClickOutside";
import classnames from "classnames";

import styles from "./Modal.module.scss";
import classNames from "classnames";

const Modal = ({
  setShowModal,
  onClose,
  isOpen = true,
  className,
  content,
  children,
  hideCloseBtn = false,
  useClickOutside,
  customBackground = false,
}) => {
  const ref = useRef();
  const closeHandler = () => {
    if (hideCloseBtn) {
      return;
    }
    // Support both old and new API patterns
    if (onClose) {
      onClose();
    } else if (setShowModal) {
      setShowModal(false);
    }
  };

  useOnClickOutside(ref, closeHandler, useClickOutside);

  // Don't render if isOpen is false
  if (!isOpen) {
    return null;
  }

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.customBackground]: customBackground,
      })}
    >
      <div className={classnames(styles.container, className)} ref={ref}>
        {!hideCloseBtn && (
          <span className={styles.close} onClick={closeHandler}>
            <Close />
          </span>
        )}
        {content || children}
      </div>
    </div>
  );
};

export default Modal;
